var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "item-row-quote-builder-misc quote-builder-item-row type-misc",
      class: [
        {
          "is-selected": _vm.isSelected,
          "is-open": _vm.isSelected && !_vm.isFullWidth,
        },
        `quote-builder-item-${_vm.$theme.name}`,
        _vm.defaultRowColourClass(
          _vm.item,
          _vm.getItemAssessments(_vm.item),
          _vm.displayDeleted
        ),
        _vm.rowDisplayStatus(_vm.item, _vm.getItemAssessments(_vm.item)),
      ],
      attrs: { id: _vm.item.quoteItemId },
      on: { click: (event) => _vm.handleClick(event) },
    },
    [
      _c("quote-builder-misc-item-template", {
        attrs: {
          "is-full-width": _vm.isFullWidth,
          "is-fully-expanded": _vm.isSelected && !_vm.isFullWidth,
          "is-selected": _vm.isSelected,
        },
        on: { handleClick: _vm.handleClick },
        scopedSlots: _vm._u(
          [
            {
              key: "description",
              fn: function () {
                return [
                  _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                    _c("div", { staticClass: "grid is-align-items-center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cell is-col-span-11 is-flex is-flex-direction-column",
                          class: [
                            _vm.defaultCellColourClass(_vm.item, "itemDesc"),
                          ],
                        },
                        [
                          _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyComputed &&
                          !_vm.readOnlyView &&
                          !_vm.audanetLock &&
                          _vm.$company.setting.itemAutoCompleteEnabled &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("item-description-autocomplete", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                ],
                                attrs: {
                                  "schedule-id": "",
                                  "body-id": "",
                                  id: _vm.item.quoteItemId + "-itemDesc",
                                  "class-prop":
                                    (!_vm.isValidItemDesc(_vm.item.quoteItemId)
                                      ? "is-danger "
                                      : "") +
                                    _vm.defaultRowColourClass(
                                      _vm.item,
                                      _vm.getItemAssessments(_vm.item)
                                    ),
                                  "item-type": _vm.itemTypes.MISC,
                                  "times-style": _vm.itemTypes.MISC,
                                },
                                model: {
                                  value: _vm.item.itemDesc,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "itemDesc", $$v)
                                  },
                                  expression: "item.itemDesc",
                                },
                              })
                            : _vm.isSelected &&
                              !_vm.item.deleteOtherItem &&
                              !_vm.readOnlyComputed &&
                              !_vm.readOnlyView &&
                              !_vm.audanetLock &&
                              !_vm.$company.setting.itemAutoCompleteEnabled &&
                              !_vm.isItemRemoved(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item)
                              )
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.itemDesc,
                                    expression: "item.itemDesc",
                                  },
                                ],
                                staticClass: "input",
                                class: [
                                  _vm.defaultRowColourClass(
                                    _vm.item,
                                    _vm.getItemAssessments(_vm.item)
                                  ),
                                  !_vm.isValidItemDesc(_vm.item.quoteItemId)
                                    ? "is-danger"
                                    : "",
                                ],
                                attrs: {
                                  placeholder: "Item Description",
                                  id: _vm.item.quoteItemId + "-itemDesc",
                                },
                                domProps: { value: _vm.item.itemDesc },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.item,
                                      "itemDesc",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "is-quote-item-field-editable pl-2",
                                  class: {
                                    "has-text-danger is-italic":
                                      !_vm.isValidItemDesc(
                                        _vm.item.quoteItemId
                                      ),
                                  },
                                  attrs: {
                                    id: _vm.item.quoteItemId + "-itemDesc",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.item.itemDesc || "Description")
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "report_blend",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-flex is-clickable",
                      class: {
                        disabled:
                          _vm.item.deleteOtherItem ||
                          !_vm.canMakeReportOnly(_vm.item),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateReport(_vm.item, $event)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { theme: "secondary", enabled: true },
                              expression:
                                "{ theme: 'secondary', enabled: true }",
                            },
                          ],
                          staticClass: "tag p-1 px-2",
                          class: _vm.item.reportOnly
                            ? "is-dark is-danger"
                            : "is-white",
                          attrs: { content: "Report" },
                        },
                        [_vm._v(" R ")]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "total_value",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-flex",
                      class: [_vm.defaultCellColourClass(_vm.item, "value")],
                    },
                    [
                      _vm.isSelected &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right",
                            class: _vm.defaultRowColourClass(
                              _vm.item,
                              _vm.getItemAssessments(_vm.item)
                            ),
                            attrs: {
                              id: _vm.item.quoteItemId + "-value",
                              disabled:
                                _vm.item.quantityReceived > 0 &&
                                !_vm.$userInfo.isSupportUser,
                              precision: 2,
                              minus: true,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateTotal(_vm.item)
                              },
                            },
                            model: {
                              value: _vm.item.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "value", _vm._n($$v))
                              },
                              expression: "item.value",
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable",
                              class: { "has-text-danger": !_vm.item.value },
                              attrs: { id: _vm.item.quoteItemId + "-value" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.value,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "present_as",
              fn: function () {
                return [
                  _c("present-as-component", {
                    attrs: { item: _vm.item },
                    on: {
                      handlePresentAs: function ($event) {
                        !_vm.readOnlyComputed &&
                          _vm.$emit("handlePresentAs", _vm.item)
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
            _vm.item.itemComment
              ? {
                  key: "comment",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: _vm.item.itemComment,
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content:item.itemComment }",
                            },
                          ],
                        },
                        [
                          _c("span", {
                            staticClass:
                              "mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable",
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "assessment_status",
              fn: function () {
                return [
                  (_vm.innerValue.quoteAssessments?.length || 0) > 0
                    ? _c("supplementary-icon", {
                        staticClass: "icon",
                        attrs: {
                          item: _vm.item,
                          "item-assessments": _vm.getItemAssessments(_vm.item),
                          "next-assessment-number": _vm.nextSupplemetryNo,
                          "quoting-method": _vm.innerValue.quotingMethod,
                          "icon-size": 4,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "delete_button",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-ghost tooltip is-align-items-center p-0 mx-1 has-text-grey-lighter",
                      attrs: {
                        "data-tooltip": "Delete Misc Item",
                        disabled: _vm.readOnlyComputed,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("deleteItem", _vm.item)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-symbols-rounded",
                          class: { "is-clickable": !_vm.readOnlyComputed },
                          on: {
                            mouseenter: function ($event) {
                              return $event.target.classList.add(
                                "has-text-danger"
                              )
                            },
                            mouseleave: function ($event) {
                              return $event.target.classList.remove(
                                "has-text-danger"
                              )
                            },
                          },
                        },
                        [_vm._v(" delete ")]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "drag_handle",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-ghost tooltip is-align-items-center p-0 mx-1 item-drag-handle has-text-grey-light",
                      attrs: {
                        "data-tooltip": "Drag",
                        disabled: _vm.readOnlyComputed,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "mdi mdi-drag-vertical mdi-24px",
                        class: { "is-clickable": !_vm.readOnlyComputed },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "lineNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Line Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Line Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      _vm.$userInfo.isSupportUser &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right",
                            class: _vm.defaultRowColourClass(
                              _vm.item,
                              _vm.getItemAssessments(_vm.item)
                            ),
                            attrs: { precision: 0, separator: "" },
                            model: {
                              value: _vm.item.lineNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "lineNumber", _vm._n($$v))
                              },
                              expression: "item.lineNumber",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.lineNumber))]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemNo,
                                expression: "item.itemNo",
                              },
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item)
                              ),
                              !_vm.isValidItemNo(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: { placeholder: "Item No." },
                            domProps: { value: _vm.item.itemNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemNo",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemNo))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemStatus",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Status",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Status' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemStatus,
                                expression: "item.itemStatus",
                              },
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            domProps: { value: _vm.item.itemStatus },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemStatus",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemStatus))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }